import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Thin gold progress bar at the top of the viewport — gives the long
 * scroll a measured, premium feel.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 110,
    damping: 24,
    restDelta: 0.001,
  });

  return (
    <motion.div
      data-testid="scroll-progress"
      className="scroll-progress"
      style={{ scaleX }}
    />
  );
}
